import home, { getServerSideProps } from './home';
export default home;
export { getServerSideProps };
